import {gql} from "@apollo/client";
import { client } from "graphql/client";
import {DeliveryTaskOrderType, DELIVERY_TASK_ORDER_DETAIL_FIELDS} from "../types/DeliveryTaskOrderType";

export const HANDLE_DELIVERED = gql`
  mutation DeliveryMutation($input: DeliveredEventInput!) {
    result: handleDeliveredEvent(input: $input) {
      ...DeliveryTaskOrderFields
    }
  }
  ${DELIVERY_TASK_ORDER_DETAIL_FIELDS}
`;

// 单张拍照照片的完整信息
export interface CameraPhotoInfo {
    s3Key: string;           // S3 存储路径
    latitude: number;        // 拍照时的纬度（如果没有则为0）
    longitude: number;       // 拍照时的经度（如果没有则为0）
}

// 相册照片组信息（共享一个位置）
export interface UploadPhotosInfo {
    latitude: number;        // 上传时的纬度（如果没有则为0）
    longitude: number;       // 上传时的经度（如果没有则为0）
}

export const HANDLE_DSP_DELIVERED = gql`
  mutation HandleDspDeliveredEvent($input: DeliveredEventInput!) {
    result: handleDspDeliveredEvent(input: $input) {
      ...DeliveryTaskOrderFields
    }
  }
  ${DELIVERY_TASK_ORDER_DETAIL_FIELDS}
`;

export interface DeliveredEventInput {
    trackingNumber: string;
    location: {
        latitude: number;
        longitude: number;
    };
    deliveredAt: string;
    podImageS3KeysJson?: string[]; // ✅ 保留原有字段（向后兼容）
    cameraPhotos?: CameraPhotoInfo[]; // ✅ 新增字段：拍照获得的照片（每张照片独立经纬度）
    uploadPhotos?: UploadPhotosInfo | null; // ✅ 新增字段：相册选择的照片（共享一个经纬度）
    id: number;
    deliveryMethod?: string | null; // 妥投方式
}

export interface DeliveredEventInputVariables {
    input: DeliveredEventInput;
}

export interface DeliveredEventResponse {
    result: DeliveryTaskOrderType;
}

export const handleDeliveredEvent = async (input: DeliveredEventInput): Promise<DeliveryTaskOrderType | undefined>  => {
    const { data } = await client.mutate<DeliveredEventResponse, DeliveredEventInputVariables>({
        mutation: HANDLE_DELIVERED,
        variables: { input },
    });
    return data?.result;
};

export const handleDspDeliveredEvent = async (input: DeliveredEventInput): Promise<DeliveryTaskOrderType | undefined>  => {
    const { data } = await client.mutate<DeliveredEventResponse, DeliveredEventInputVariables>({
        mutation: HANDLE_DSP_DELIVERED,
        variables: { input },
    });
    return data?.result;
};